import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { FavoritesImplementation } from '../implementation/FavoritesImplementation';

export class FavoritesController extends Controller{
    public favoritesImplementation:any;
    public fileOperationsImplementation:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null;
    public universalService:any;
    public listService:any;
    loggerService: any;
    lazyLoadImgService:any;

    public constructor(private globalService:GlobalService) {
      super(globalService);
      this.favoritesImplementation= FavoritesImplementation.getInstance(globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
    }
    
    public static getInstance(connectionService):FavoritesController{
		if(this.singleInstance == null){
			this.singleInstance = new FavoritesController(connectionService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef();
      this.listService = globalService.getListServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();   
      this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
      if(this.universalService.virtualGridEnabled){
        this.lazyLoadImgService = globalService.getVirtualLazyLoadImgServiceRef();
      }
    }

    async getMyFilesFavorites(tab){
        this.universalService.nameSort = null;
        var url = "";
        let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsMetaData"] + ENV_CONFIG.commonUrls["favorites"] + "?sort=" + this.favoritesImplementation.sortType + "&limit=" + limit + "&filterType=S&page=0"
        this.favoritesImplementation.setHandler(this.globalService);
        await this.favoritesImplementation.fetchFavorites(url,tab);

    }

    async getMyAlbumsFavorites(tab){
        this.universalService.nameSort = null;
        var url = "";
        let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumsMetaData"] + ENV_CONFIG.commonUrls["favorites"] + "?sort=" + this.favoritesImplementation.sortType + "&limit=" + limit;
        this.favoritesImplementation.setHandler(this.globalService);
        await this.favoritesImplementation.fetchFavorites(url,tab);

    }
    
    decideScrollCall(){
        if(this.listService.listOptions.api.getDisplayedRowCount() == 0) return
        this.onListScrollDown();
    }

    onListScrollDown() { // this will get called when user is inside folder in list view only
      var url = this.favoritesImplementation.currentTab == 'My Files' ? ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] : ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"];
      url += this.favoritesImplementation.favNextLink;
      try {
        this.favoritesImplementation.createUrlForNextLinkForListView(url);
      }
      catch (exc) {
        this.loggerService.log("exception in scroll down")
      }
    }

    onScrollDown(docheignt,toppos){
      let self = this;
      if(!this.universalService.virtualGridEnabled){
        self.lazyLoadImgService.isScrollingStopped();
      }
      var url = this.favoritesImplementation.currentTab == 'My Files' ? ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] : ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"];
      url += self.favoritesImplementation.favNextLink;
      try{
        self.favoritesImplementation.createUrlForNextLink(docheignt,toppos,url);
      }
      catch(exc){
        self.loggerService.log("exception in scroll down")
      }
    }


    async updateUIAfterPerformingAction(list,executedTask){
      var array = [];
      array = this.favoritesImplementation.sortByDateArray;
      if(executedTask == 'TRASH' || executedTask == "MOVE"){
          if(executedTask == "MOVE" && this.universalService.selectedFolder.objectName == 'Private Folder'){
              executedTask = "MOVETOPF"
          }
          if((this.universalService.showPreview && executedTask == 'TRASH')||!this.universalService.showPreview || executedTask == "MOVETOPF"){
            this.fileOperationsImplementation.setHandler(this.globalService);
            var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
            array = result
            if(array.length == 0){
              this.getNextPageData();
            }
          } else{
            this.listService.deSelectAll(null);
          }
          this.universalService.emptyTab = false;
      }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == 'FRN' || executedTask == 'SHAREPERMISSION'){
          this.fileOperationsImplementation.setHandler(this.globalService);
          var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
          array = result
          if(array.length == 0 && executedTask == 'UNSETFAV' && this.universalService.currentTab == 'Favorites'){
            this.getNextPageData();
          }
          this.universalService.emptyTab = false;
      }else{
          this.loggerService.log("task invalid",executedTask)
      }

      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
    }

  selectAll(event){
    this.favoritesImplementation.selectAll(event)
  }

  getNextPageData(){
    if(this.favoritesImplementation.currentTab == "My Files"){
      this.getMyFilesFavorites(this.favoritesImplementation.currentTab);
    }else if(this.favoritesImplementation.currentTab == "Album Files"){
      this.getMyAlbumsFavorites(this.favoritesImplementation.currentTab);
    }
  }

}